import { AlertTriangle, Loader2 } from 'lucide-react';

export function LoadingScreen({ label = 'Loading your module…' }: { label?: string }) {
  return (
    <div
      className="flex flex-col items-center gap-3 py-24 text-slate-500"
      data-testid="loading-screen"
    >
      <Loader2 size={28} className="animate-spin" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function ErrorScreen({ message }: { message: string }) {
  return (
    <div className="mx-auto max-w-lg py-20 text-center" data-testid="error-screen">
      <AlertTriangle size={40} className="mx-auto text-amber-500" />
      <h2 className="mt-4 text-xl font-semibold">We could not open this module</h2>
      <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{message}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-6 rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium dark:border-slate-700"
      >
        Try again
      </button>
    </div>
  );
}

export function ProgressBar({ percent, label }: { percent: number; label: string }) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-xs text-slate-500">
        <span>{label}</span>
        <span>{percent}%</span>
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800">
        <div
          className="h-full rounded-full bg-brand-600 transition-all"
          style={{ width: `${percent}%` }}
          role="progressbar"
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
}
